<template>
  <v-card elevation="3">
    <v-toolbar
      flat
      color="primary"
      dark
    >
      <v-toolbar-title>Delivery information for Sofie Account Number: {{ sofieId }}</v-toolbar-title>
    </v-toolbar>
    <shipped-to :ship-to-address-info="shipToAddressInfo" />
  </v-card>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { SofieShipToAddress } from "@/types/types";
import ShippedToVue from "./ShippedTo.vue";

export default defineComponent({
  components: {
    "shipped-to": ShippedToVue,
  },
  props: {
    shipToAddressInfo: {
      type: Object as PropType<SofieShipToAddress>,
      required: true,
    },
    sofieId: {
      type: String,
      required: true,
    },
  },
});
</script>
